export const CHANGE_TYPES = [
  { value: "deliverables", label: "Deliverables" },
  { value: "features", label: "Features" },
  { value: "exclusions", label: "Exclusions" },
  { value: "dependencies", label: "Dependencies" },
  { value: "risks", label: "Risks" },
  { value: "other", label: "Other" },
];

